<template>
  <div class="inner-content">
    <div
      class="submitted-content--bold mt-10"
      v-html="
        $t('OrderInfo_information_on_the_further_process' + ORDER_INFO_PAGE_SUFFIXES.no_sample)
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_once_we_have_received_your_complete_order' + ORDER_INFO_PAGE_SUFFIXES.no_sample
        )
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_you_will_receive_a_notification' + ORDER_INFO_PAGE_SUFFIXES.no_sample
        )
      "
    />
    <div
      class="submitted-content--bold mt-10"
      v-html="
        $t('OrderInfo_need_help' + ORDER_INFO_PAGE_SUFFIXES.no_sample)
      "
    />
    <div
      v-html="
        $t(
          'OrderInfo_in_case_of_any_questions' + ORDER_INFO_PAGE_SUFFIXES.no_sample
        )
      "
    />
  </div>
</template>

<script setup lang="ts">
import { ORDER_INFO_PAGE_SUFFIXES } from '@/utils/constants'

defineOptions({ name: "OrderSubmittedNoSample" });

</script>W
